import React from 'react';

export default function AIRapGuide() {
  return (
    <div className="min-h-screen flex items-center justify-center text-white">
      <div className="text-center p-8">
        <h1 className="text-4xl font-bold mb-4">AI Rap Guide</h1>
        <p className="text-gray-300">This page is under construction.</p>
      </div>
    </div>
  );
}
